import { gql }  from '@apollo/client';

const FIND_MEMBER = gql`
  query ($id: ID!){
    member(id: $id){
      id
      fullNm
      primary
      sourceMemberId
      effectiveStartDate
      effectiveEndDate
      sourceMemberId
      mrns {
        mrnId
        group {
          id
          effective
          name
          registrationCode
          oneAppFlag
          effectiveStartDate
          effectiveEndDate
        }
        coverageStartDate
        coverageEndDate
        sourceMrnId
        sourceHealthPlanId
        isActive
        isPrimary
        serviceSpecialties {
          name
          startDate
          endDate
        },
      },
      serviceSpecialties {
        name
        startDate
        endDate
      }
    }
  }
  `;

export default FIND_MEMBER;
